/** Group of the salespeople, "Commercial": the same id in every environment. */
export const ATTENDANCE_DEFAULT_GROUP_IDS = [1];
